<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import { definePage } from "unplugin-vue-router/runtime";
import InviteRecipientRespondForm from "@/components/models/invite/InviteRecipientRespondForm.vue";

definePage({
  meta: {
    title: "models.invitations.acceptInvitation",
    requiresAuth: true,
  },
});

const route = useRoute();

const recipientId = computed(() => ("id" in route.params ? String(route.params.id) : ""));
</script>

<template>
  <invite-recipient-respond-form
    v-if="recipientId"
    :recipient-id="recipientId"
  />
</template>
